import { RECERT_CERT_TYPE } from '../../constants/affordableCertificationTypes';
import moment from 'moment-business-days';
import { COMPLIANCE_APPROVAL_STATUSES } from '../../constants/affordableComplianceApprovalStatuses';

const CHECK_HOUR = 14;
const FINAL_BUSINESS_DAYS = 4;
const RECERT_BUSINESS_DAYS = 7;
const OTHER_BUSINESS_DAYS = 2;

// Needs Review's "Review Overdue": a still-pending document uploaded more
// than the allotted business days ago. Past-due itself comes from the
// backend's recertRange, not from here.
export const isDocumentReviewOverdue = ({
  certificationType,
  complianceApprovalStatus,
  complianceDocumentType,
  uploadDate,
}) => {
  const documentUploadDate = uploadDate ? moment(uploadDate) : null;

  if (!documentUploadDate) {
    return null;
  }

  if (!isApprovalStatusPendingOrSimilar(complianceApprovalStatus)) {
    return false;
  }

  return documentUploadDate.isBefore(
    setLateDate(certificationType, complianceDocumentType),
  );
};

const isApprovalStatusPendingOrSimilar = (approvalStatus) => {
  return [
    COMPLIANCE_APPROVAL_STATUSES.pending,
    COMPLIANCE_APPROVAL_STATUSES.pendingFinalApproval,
    COMPLIANCE_APPROVAL_STATUSES.correctionNeeded,
    COMPLIANCE_APPROVAL_STATUSES.approvedPendingSign,
    COMPLIANCE_APPROVAL_STATUSES.none,
    null,
  ].includes(approvalStatus);
};

const setLateDate = (certificationType, complianceDocumentType) => {
  let businessDays;

  if (complianceDocumentType?.includes('Final')) {
    businessDays = FINAL_BUSINESS_DAYS;
  } else {
    businessDays = isRecert(certificationType)
      ? RECERT_BUSINESS_DAYS
      : OTHER_BUSINESS_DAYS;
  }

  return moment().hour(CHECK_HOUR).businessSubtract(businessDays, 'days');
};

const isRecert = (certificationType) => {
  return certificationType === RECERT_CERT_TYPE;
};
